import { openMenu, closeMenu, open_menu_state } from '@/functions/function.js';
import $ from 'jquery'
import Nouveautes from '@/components/nouveautes'
import { stockLandingRoute } from '@/utils/stock-landing'

export default {
    name: 'navbar',
    components: { Nouveautes },
    props: { sidebarCollapsed: Boolean },
    data() {
        return {
            user_role: '',
            compte_id: 0,
            user_id: 0,
            all_apps: false,
            menu_state: 0,
            vm_state: open_menu_state,
            counter: 0,
            remaining_time: {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            },
            is_close: 0
        };
    },  
    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole(){
            return this.$store.getters['activeRole'];
        },

        auth_user(){
            return this.$store.getters['auth_user'];
        },

        sortedRoles() {
            const roles = this.auth_user && Array.isArray(this.auth_user.roles) ? this.auth_user.roles : []
            return roles.slice().sort((a, b) => Number(!!this.activeRole && b.nom === this.activeRole.nom) - Number(!!this.activeRole && a.nom === this.activeRole.nom))
        },

        activeRoleLabel() {
            const selected = this.sortedRoles.find(role => this.activeRole && role.nom === this.activeRole.nom)
            return selected ? selected.description : (this.auth_user && this.auth_user.titre) || ''
        },

        countdown_info() {
            return this.$store.getters['countdown_info'];
        }
    },

    mounted() {
        this.$store.dispatch('getCountDown').then(() => {
            this.calcTimeRemaining()
        })

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            this.$store.dispatch("getAuthUser", { user_id: this.user_id })
        }

        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            
            if (!$clicked.parents().hasClass("menu-container")) {
                if(t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'user-menu')
                }
            }

            if (!$clicked.parents().hasClass("menu-container")) {
                if (t.menu_state != 0) {
                    $('.all-apps').removeClass('animate-zoomIn');
                    $('.all-apps').addClass('animate-zoomOut');
                    $('.all-apps').fadeOut();
                    t.menu_state = 0;
                }
                
            }
        });
        
        // Listen for closeSidebar event from sidebar component
        this.$root.$on('closeSidebar', () => {
            if (this.is_close == 1) {
                this.toggleSidebar();
            }
        });
        this.handleRoleOutsidePointer = event => {
            const switcher = this.$refs.profileSwitcher
            if (switcher && switcher.open && !switcher.contains(event.target)) this.closeRoleMenu()
        }
        this.handleRoleEscape = event => { if (event.key === 'Escape') this.closeRoleMenu() }
        document.addEventListener('pointerdown', this.handleRoleOutsidePointer, true)
        document.addEventListener('keydown', this.handleRoleEscape, true)

        this.getCurrencyInfo()
    },

    beforeDestroy() {
        // Clean up event listener
        clearTimeout(this.roleMenuTimer)
        document.removeEventListener('pointerdown', this.handleRoleOutsidePointer, true)
        document.removeEventListener('keydown', this.handleRoleEscape, true)
        this.$root.$off('closeSidebar');
    },

    methods: {
        toggleRoleMenu() {
            const switcher = this.$refs.profileSwitcher
            if (!switcher) return
            if (switcher.classList.contains('is-closing')) {
                clearTimeout(this.roleMenuTimer)
                switcher.classList.remove('is-closing')
            } else if (switcher.open) {
                this.closeRoleMenu()
                return
            }
            switcher.open = true
        },
        closeRoleMenu() {
            const switcher = this.$refs && this.$refs.profileSwitcher
            if (!switcher || !switcher.open || switcher.classList.contains('is-closing')) return
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                switcher.open = false
                return
            }
            switcher.classList.add('is-closing')
            this.roleMenuTimer = setTimeout(() => {
                switcher.open = false
                switcher.classList.remove('is-closing')
            }, 180)
        },
        getCurrencyInfo() {
            this.$store.dispatch('getConfigInfoClinique', 'currency')
        },

        calcTimeRemaining() {
            this.counter = this.countdown_info.duree_restant.total_secondes
            
            setInterval(() => {
                let total_seconds = this.counter;

                // Convert the remaining time back to days, hours, minutes, and seconds
                let remaining_days = Math.floor(total_seconds / (24 * 60 * 60));
                total_seconds %= (24 * 60 * 60);

                let remaining_hours = Math.floor(total_seconds / (60 * 60));
                total_seconds %= (60 * 60);

                let remaining_minutes = Math.floor(total_seconds / 60);
                let remaining_seconds = total_seconds % 60;

                this.remaining_time = {
                    days: remaining_days,
                    hours: remaining_hours,
                    minutes: remaining_minutes,
                    seconds: remaining_seconds
                }
                
                this.counter -= 1
            }, 1000)
        },

        displayapps: function(e) {
            e.preventDefault();
            this.all_apps = !this.all_apps;
        },
        
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector) 
        {
            this.vm_state = openMenu.dropMenu(state, selector)
        },

        /**
        * Close Menu Dropdown
        */
        async closeMenu(selector) 
        {
            this.vm_state = closeMenu.wrapMenu(selector)
        },

        resetVuexState() {
            const freshState = {};
            const modules = this.$store._modules.root._children || {};

            Object.keys(modules).forEach((moduleName) => {
                const module = modules[moduleName];
                const moduleState = typeof module.state === 'function' ? module.state() : module.state;

                freshState[moduleName] = moduleState && typeof moduleState === 'object'
                    ? { ...moduleState }
                    : moduleState;
            });

            this.$store.replaceState(freshState);
        },

        async logout()
        {
            this.resetVuexState();
            localStorage.removeItem('vuex');
            localStorage.clear();
            this.$router.push({"path": "/login"})
        },

        /**
         * URL de l'écran « Contrôle des sorties » de fe_caisse (PORT-001).
         */
        urlPortailSorties() {
            return String(this.base_url_caisse || '').replace(/\/+$/, '') + '/portail/sorties'
        },

        /**
         * Basculer de role
         * @param {*} userId 
         * @param {*} roleId 
         * @param {*} role_nom nom du rôle (PORT-001 : aiguillage par nom, les ids varient selon l'environnement)
         */
        switchRole: function(userId, roleId, role_nom){
            if (role_nom == 'ROLE_AGENT_SECURITE') {    // AGENT DE SÉCURITÉ → contrôle des sorties (fe_caisse)
                window.location = this.urlPortailSorties()
            } else if (role_nom == 'ROLE_RESPONSABLE_LOGISTIQUE' || role_nom == 'ROLE_PHARMACIEN' || role_nom == 'ROLE_PHARMACIEN_INTERMITENT') {
                this.$store.dispatch('switchRole', { userId: userId, roleId: roleId }).then(() => {
                    this.$router.push({ path: stockLandingRoute([], { nom: role_nom }) })
                })
            } else if (roleId == 2 || roleId == 3 || roleId == 7 || roleId == 16 || roleId == 17) {
                window.location = this.base_url_clinique
            } else if (roleId == 18 || roleId == 4 || roleId == 5 || roleId == 14) {
                window.location = this.base_url_caisse
            } else if (roleId == 11) {           // ROLE_RH
                window.location = this.base_url_rh
            } else {
                this.$store.dispatch('switchRole', { userId: userId, roleId: roleId }).then(() => {
                    // this.$router.push({ "path": "/" })
                })
            }
        },

        toggleSidebar() {
            this.is_close = (this.is_close == 0)?1:0

            if (this.is_close == 1) {
                $('.sidebar').addClass('shw-sdbar');
            } else {
                $('.sidebar').removeClass('shw-sdbar');
            }
        }
    }
}
